var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _vm.definition.type === _vm.CardAttributeDefinitionType.String
        ? [
            _vm._v("\n    " + _vm._s(_vm.definition.name) + "\n    "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.attribute.value,
                  expression: "attribute.value"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.attribute.value },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.attribute, "value", $event.target.value)
                }
              }
            })
          ]
        : _vm.definition.type === _vm.CardAttributeDefinitionType.Integer
        ? [
            _vm._v("\n    " + _vm._s(_vm.definition.name) + "\n    "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.attribute.value,
                  expression: "attribute.value"
                },
                { name: "forcevalid", rawName: "v-forcevalid" }
              ],
              staticClass: "form-control",
              attrs: { type: "text", pattern: "[0-9]*" },
              domProps: { value: _vm.attribute.value },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.attribute, "value", $event.target.value)
                }
              }
            })
          ]
        : _vm.definition.type === _vm.CardAttributeDefinitionType.Datetime
        ? [
            _vm._v("\n    " + _vm._s(_vm.definition.name) + "\n    "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dateValue,
                  expression: "dateValue"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "datetime-local" },
              domProps: { value: _vm.dateValue },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.dateValue = $event.target.value
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.definition.type === _vm.CardAttributeDefinitionType.Link
        ? [
            _vm._v("\n    " + _vm._s(_vm.definition.name) + "\n    "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.attribute.value,
                  expression: "attribute.value"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.attribute.value },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.attribute, "value", $event.target.value)
                }
              }
            })
          ]
        : _vm.definition.type === _vm.CardAttributeDefinitionType.Signature
        ? [
            _vm._v("\n    " + _vm._s(_vm.definition.name) + "\n    "),
            _c("img", { attrs: { src: _vm.attribute.value } })
          ]
        : _vm.definition.type === _vm.CardAttributeDefinitionType.SurveyResult
        ? [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                on: {
                  click: function($event) {
                    return _vm.openSurveyResult(_vm.attribute.value)
                  }
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("survey.group.resultsModal.title")) +
                    "\n    "
                )
              ]
            ),
            _vm._v(" "),
            _c("AnswersModal", { ref: "answerModal" })
          ]
        : _vm.definition.type === _vm.CardAttributeDefinitionType.Form
        ? [
            _c("VueFormAttribute", {
              attrs: { definition: _vm.definition, attribute: _vm.attribute }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }